import { render, staticRenderFns } from "./ChatVisitsTable.vue?vue&type=template&id=573a5fc2&"
import script from "./ChatVisitsTable.vue?vue&type=script&lang=js&"
export * from "./ChatVisitsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports